import { render, staticRenderFns } from "./OnePackage.vue?vue&type=template&id=15ecbbc2&scoped=true&"
import script from "./OnePackage.vue?vue&type=script&lang=js&"
export * from "./OnePackage.vue?vue&type=script&lang=js&"
import style0 from "./OnePackage.vue?vue&type=style&index=0&id=15ecbbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ecbbc2",
  null
  
)

export default component.exports